import { Component, OnInit, OnDestroy } from '@angular/core';

import { InfoProfileService } from '../info-profile.service';
import { UserProfile } from '../user-profile.model';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-user-personal-information',
  templateUrl: './user-personal-information.component.html',
  styleUrls: ['./user-personal-information.component.css']
})
export class UserPersonalInformationComponent implements OnInit, OnDestroy {

  userName: string;
  userPicture: string;

  private userProfileSubscription: Subscription;

  constructor(private infoProfileService: InfoProfileService) { }

  ngOnInit() {

    this.userProfileSubscription = this.infoProfileService.getUserProfile().subscribe((userProfile: UserProfile) => {
      if (userProfile) {
        this.userName = this.formatUserName(userProfile.userName);
        this.userPicture = userProfile.userPicture;
      }
    });
  }

  ngOnDestroy() {
    if (this.userProfileSubscription) {
      this.userProfileSubscription.unsubscribe();
    }
  }

  private formatUserName(fullName: string): string {
    
    let result = fullName.split(' ');
    let firstName: string = result[0].trim();
    let lastName: string = '';

    if (result.length > 1)
      lastName = result.reverse()[0];

    return firstName + ' ' + lastName;
  }
}
